import React from 'react';
import RcTooltip from 'rc-tooltip';

const Tooltip = ({ children, placement, text }) => {
  return (
    <RcTooltip placement={placement} overlay={<span>{text}</span>}>
      {children || <div className="c-tooltip" />}
    </RcTooltip>
  );
};

Tooltip.defaultProps = {
  placement: 'right',
};

export default Tooltip;
